import { Theme } from '@mui/material';

export const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'auto',
  bgcolor: 'background.default',
  border: '1px solid #fff',
  boxShadow: 24,
  p: 4,
};

export const paperDialogStyle = (theme: Theme) => ({
  backgroundColor: theme.palette.background.paper,
  border: '1px solid #fff',
  padding: 4,
  backgroundImage: 'none',
  boxShadow: theme.shadows[24],
  minWidth: '312px',
});
